app.factory('Services', [
  'liferay',
  function(liferayService) {
    return {
      saveClientRegistration : function(
		registrationData, isAgree, isAgree1,
		isAgree2, isAgree3, isAgree4, isAgree5,
		fileId0, fileId1, fileId2, fileId3,
		fileId4, fileId5) {
        var req = {
          liferayId: registrationData.liferayId,
          title: registrationData.title === '-' ?
            '' : registrationData.title,
          firstName: registrationData.firstName,
          lastName: registrationData.lastName,
          motherName: registrationData.motherName,
          birthplace: registrationData.birthplace,
          birthdate: registrationData.birthdate ?
            registrationData.birthdate.momentDate.format('YYYY-MM-DD') : null,
          zip: registrationData.zip,
          city: registrationData.city,
          street: registrationData.street,
          email: registrationData.email,
          phoneNumber: registrationData.phoneNumber ?
            '36' + registrationData.phoneNumber : null,
          registrationCode: registrationData.registrationCode,
          partnerCode: registrationData.partnerCode,
          date1: registrationData.otherField1 ? registrationData.otherField1.momentDate.format('YYYY-MM-DD') : null,
          date2: registrationData.otherField2 ? registrationData.otherField2.momentDate.format('YYYY-MM-DD') : null,
          date3: registrationData.otherField3 ? registrationData.otherField3.momentDate.format('YYYY-MM-DD') : null,
          text4: registrationData.otherField4,
          text5: registrationData.otherField5,
          text6: registrationData.otherField6,
          text7: registrationData.otherField7,
          text8: registrationData.otherField8,
          text9: registrationData.otherField9,
          text10: registrationData.otherField10,
          text11: registrationData.otherField11,
          text12: registrationData.otherField12,
          text13: registrationData.otherField13,
          text14: registrationData.otherField14,
          text15: registrationData.otherField15,
          isAgree: isAgree,
          isAgree1: isAgree1,
          isAgree2: isAgree2,
          isAgree3: isAgree3,
          isAgree4: isAgree4,
          isAgree5: isAgree5,
          fileId0: fileId0,
          fileId1: fileId1,
          fileId2: fileId2,
          fileId3: fileId3,
          fileId4: fileId4,
          fileId5: fileId5,
          insuranceStartDate: registrationData.insuranceStartDate ?
                  registrationData.insuranceStartDate.momentDate.format('YYYY-MM-DD') : null,
          insuranceEndDate: registrationData.insuranceEndDate ?
                  registrationData.insuranceEndDate.momentDate.format('YYYY-MM-DD') : null
        }

        return liferayService.get(pURL.saveClientRegistration, req).then(
          function(response) {
            return response.data
          }
        )
      },
      
      partnerCodeValidation: function(registrationData) {
          var req = {
            partnerCode: registrationData.partnerCode,
          }

          return liferayService.get(pURL.partnerCodeValidation, req).then(
            function(response) {
              return response.data
            }
          )
        },

      clientProfileAddContract: function() {
        var req = {}

        return liferayService.get(pURL.clientProfileAddContract, req).then(
          function(response) {
            return response.data
          }
        )
      },

      getCityList: function(zip) {
        var req = {
          zip: zip
        }

        return liferayService.get(pURL.cityList, req).then(
          function(response) {
            return response.data
          }
        )
      },

      getStreetList: function(zip) {
        var req = {
          zip: zip,
          query: ''
        }

        return liferayService.get(pURL.streetList, req).then(
          function(response) {
            return response.data
          }
        )
      },
      
      getPageParameters: function() {
    	  return liferayService.get(pURL.getPageParameters).then(
            function(response) {
              return response.data
            }
          )
      },
      
      getStatementParameters: function() {
    	  return liferayService.get(pURL.getStatementParameters).then(
            function(response) {
              return response.data
            }
          )
      },
      
      fillConfigLists: function() {
    	  return liferayService.get(pURL.fillConfigList).then(
    		function(response) {
    	      return response.data
    	     }
    	    )
      }
    }
  }
])

app.factory('SessionStorage',
  function() {
    return {
      // -----------------------------------------------------------------------
      setRegistrationData: function(data) {
        if (typeof data === 'undefined') {
          return null
        }

        var registrationData = data

        if (data.title && data.title === '-') {
          delete registrationData.title
        }

        sessionStorage.setItem('registrationData', JSON.stringify(registrationData))

        return registrationData
      },
      // -----------------------------------------------------------------------
      getRegistrationData: function() {
        var registrationData = JSON.parse(sessionStorage.getItem('registrationData'))

        if (registrationData.birthdate.momentDate) {
          registrationData.birthdate.momentDate = moment(registrationData.birthdate.momentDate)
        }
        
        if (registrationData.otherField1) {
          registrationData.otherField1.momentDate = moment(registrationData.otherField1.momentDate)
        }

        if (registrationData.otherField2) {
          registrationData.otherField2.momentDate = moment(registrationData.otherField2.momentDate)
        }

        if (registrationData.otherField3) {
          registrationData.otherField3.momentDate = moment(registrationData.otherField3.momentDate)
        }
        
        if (registrationData.insuranceStartDate != null) {
            registrationData.insuranceStartDate.momentDate = moment(registrationData.insuranceStartDate.momentDate)
        }
        
        if (registrationData.insuranceEndDate != null) {
            registrationData.insuranceEndDate.momentDate = moment(registrationData.insuranceEndDate.momentDate)
        }

        return registrationData
      },
    }
  })
